import { Injectable, inject } from "@angular/core";
import { GetConformanceGiasStandardGQL, CreateOrUpdateStandardGQL, ConformanceToGiasStandardRowInput, CreateOrUpdateStandardMutation, GetConformanceGiasStandardQuery, ComparatorOperators, ConformanceToGiasQuerySimpleInput, ConformanceToGiasStandardQueryComplexInput, ConformanceToGiasStandardQuerySimpleInput, PagingInput, OperatorInput, ConformanceToGiasStandardField, ConformanceToGiasStandardSimpleQueryInput, DeleteStandardGQL, DeleteStandardMutation } from "../../../graphql/generated";
import { map, Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ManageStandardsSrvice {
    private readonly GetConformanceGiasStandardGQL: GetConformanceGiasStandardGQL = inject(GetConformanceGiasStandardGQL);
    private readonly CreateOrUpdateStandardGQL: CreateOrUpdateStandardGQL = inject(CreateOrUpdateStandardGQL);
    private readonly DeleteStandardGQL: DeleteStandardGQL = inject(DeleteStandardGQL);

    getStandards(campaignId: string, parameters: any): Observable<GetConformanceGiasStandardQuery['getConformanceToGIASStandard']> {
        const params = convertParameters(parameters)
        return this.GetConformanceGiasStandardGQL.fetch({ campaignId, page: params.page, query: params.query }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.getConformanceToGIASStandard))
    }

    createOrUpdateStandard(campaignId: string, input: ConformanceToGiasStandardRowInput): Observable<CreateOrUpdateStandardMutation['createOrUpdateConformanceToGIASStandard']> {
        return this.CreateOrUpdateStandardGQL.mutate({ campaignId, input }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.createOrUpdateConformanceToGIASStandard))
    }

    deleteStandard(campaignId: string, id: string): Observable<DeleteStandardMutation['deleteConformanceToGIASStandard']> {
        return this.DeleteStandardGQL.mutate({ campaignId, id }, { fetchPolicy: 'no-cache' }).pipe(map(res => res.data?.deleteConformanceToGIASStandard))
    }
}

export function convertParameters(parameters: any): { query: ConformanceToGiasStandardQueryComplexInput, page: PagingInput } {
    const query: ConformanceToGiasStandardSimpleQueryInput[] = [];
    if (parameters) {

        if (parameters.filters) {

            Object.entries(parameters.filters).forEach(([field, values]) => {
                //console.log"value", values);

                if (values !== null && Array.isArray(values) && values.length > 0) {
                    (ENUM_ICS[field as keyof typeof ENUM_ICS])?.forEach(key => {

                        query.push({
                            field: key as ConformanceToGiasStandardField,
                            filters: {
                                operator: ComparatorOperators.Match,
                                value: values?.map(v => String(v)?.toLowerCase() === 'empty' ? null : v)
                            }
                        });
                    })
                }
            });
        }
    }
    return {
        query: {
            operator: OperatorInput.And,
            query: [
                {
                    query: query,
                    operator: OperatorInput.And
                }
            ]
        },
        page: {
            pageNo: parameters?.page ?? 0,
            pageSize: parameters?.rows ?? 1000000
        }
    }
}

export const ENUM_ICS = {
    order: [ConformanceToGiasStandardField.Order],
    domain: [ConformanceToGiasStandardField.Domain],
    standard: [ConformanceToGiasStandardField.Standard],
    principle: [ConformanceToGiasStandardField.Principle],
    auditValueChain: [ConformanceToGiasStandardField.AuditValueChain],
    globalInternalAuditStandards: [ConformanceToGiasStandardField.GlobalInternalAuditStandard],
    exampleOfEvidenceOfConformance: [ConformanceToGiasStandardField.ExampleOfEvidenceOdConformance],
    gaMainReferences: [ConformanceToGiasStandardField.GaMainReferences]
}